/**
 * ACA Renew Application Fields
 * For renew applications, we use the same structure as new applications
 * All fields are shown (no material/non-material selection like amend)
 */

// Import the original ACA fields
import { ACA_APPLICATION_FIELDS } from './acaApplicationDetails';

/**
 * ACA Renew Application Fields
 * Renew shows all fields without the iWantToUpdate selection
 * The only difference from new applications is the transactionType = 'Renew'
 */
export const ACA_RENEW_APPLICATION_FIELDS = ACA_APPLICATION_FIELDS;

export default ACA_RENEW_APPLICATION_FIELDS;
